import * as actionTypes from './action-types'

export const fetchInvitations = ({ page, keyword, filters } = {}) => ({
  type: actionTypes.FETCH_INVITATIONS,
  payload: { page, keyword, filters },
})

export const selectInvitation = id => ({
  type: actionTypes.SELECT_INVITATION,
  payload: { id },
})

export const selectAll = () => ({
  type: actionTypes.SELECT_ALL,
})

export const resetSelected = () => ({
  type: actionTypes.RESET_SELECTED_ON_PAGE,
})

export const fetchSearchOptions = (keyword, filters) => ({
  type: actionTypes.GET_SEARCH_OPTIONS,
  payload: { keyword, filters },
})

export const clearSearchOptions = () => ({
  type: actionTypes.CLEAR_SEARCH_OPTIONS,
})

export const removeInvitations = (ids, filters) => ({
  type: actionTypes.REMOVE,
  payload: { ids, filters },
})

export const fakeRemoveVendors = (ids, filters) => ({
  type: actionTypes.REMOVE_FAKE,
  payload: { ids, filters },
})

export const setSearchFilters = ({ keyword }) => ({
  type: actionTypes.SET_SEARCH_FILTERS,
  payload: { keyword },
})

export const resendInvitation = (id, email) => ({
  type: actionTypes.RESEND_INVITATION,
  payload: { id, email },
})

export const resendInvitationClear = () => ({
  type: actionTypes.RESEND_INVITATION_CLEAR,
})

export const confirmResendInvitation = data => ({
  type: actionTypes.CONFIRM_RESEND_INVITATION,
  payload: data,
})
